import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import moment from "moment";
import { MERCHANTIDDELIVERY } from "../../constants/Constants";
import QRCODE from "qrcode.react";
import { useMediaQuery } from "react-responsive";
import { formatCurrency } from "../../common/format-currency";
import SideMenu from "../../components/side-menu/SideMenu";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
} from "../../redux/actions/postActions";
import MyStorage from "../../common/MyStorage";
import { KMTracking } from "../../components/Tracking/KMTracking";
import Cookies from "universal-cookie";
import _ from "lodash";
import { Link } from "react-router-dom";

var kmRefundedProps = {};
var kmRefundedPropsProduct = {};
var kissMetricsDone = false;
var pageReload = true;

const cookies = new Cookies();

function RefundDetails(props) {
  const [givenName, setGivenName] = useState("");
  const [invoiceNo, setInvoiceNo] = useState("");
  const [invoiceData, setInvoiceData] = useState<any>({});
  const [type, setType] = useState("");
  const [dateAndTime, setDateAndTime] = useState("");
  const [invoiceStatus, setInvoiceStatus] = useState("");
  const [summary, setSummary] = useState("");
  const [summary2, setSummary2] = useState("");
  const [summary3, setSummary3] = useState("");
  const [OrderStatus, setOrderStatus] = useState("");
  const [imageIndex, setImageIndex] = useState(0);
  const [deliveryData, setDelivery] = useState<any>([]);
  const [orderSummaryList, setOrderSummaryList] = useState<any>([]);
  const [brandNameList, setbrandNameList] = useState<any>([]);
  const [card_type, setCardType] = useState("");
  const [card_number, setCardNumber] = useState("");
  const [deliveryItemID, setDeliveryItemID] = useState("");
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1224px)",
  });

  var ACF;
  var RefundAmount = 0;

  useEffect(() => {
    let count = parseInt(cookies.get("page_reload_count"));
    console.log("Cookie count = ", count);
    if (performance.navigation.type == performance.navigation.TYPE_RELOAD) {
      if (count == 0 || _.isNaN(count)) {
        cookies.set("page_reload_count", 1);
        pageReload = false;
      } else {
        pageReload = true;
        cookies.set("page_reload_count", count + 1);
        console.log("Page reload ==== ", pageReload);
      }
    }
    // window.onbeforeunload = function(){
    // 	cookies.set('page_reload_count', 0);
    // 	kissMetricsDone = false
    // 	setPageReload(false)
    // 	 }

    return () => {
      // cookies.set('page_reload_count', 0);
      cookies.remove("page_reload_count");
      kissMetricsDone = false;
      pageReload = false;
    };
  }, []);
  useEffect(() => {
    const orderID = props?.match?.params?.orderID;
    getInvoiceDetail(orderID);
    if (orderID !== "") {
      setInvoiceNo(orderID);
    }
    const storage = new MyStorage();
    const token = storage.getloggedIn();
    if (token == "true") {
      const given_name = localStorage.getItem("name")?.split(" ")[0];
      setGivenName(given_name ? given_name : "");
    } else {
      props?.history?.push("/login", { from: "Refund Details" });
    }
  }, []);
  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };
  var deliveryItemPrice = 0;

  const getInvoiceDetail = async (orderID) => {
    let accessToken = localStorage.getItem("access_token");
    let userID = localStorage.getItem("UserId");
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      ACF = await new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF);
    }
    const deliveryItemID = ACF !== "" && ACF["FrasersDeliveryItemID"];
    if (deliveryItemID !== "") {
      setDeliveryItemID(deliveryItemID);
    }
    new WebApiCalls()
      .getALlInvoices(userID, accessToken, 1, 10, false, orderID)
      .then((_response) => {
        if (_response.Records && _response?.Records?.length > 0) {
          kmRefundedProps = {
            currency: _response.Records[0].CurrencyCode,
            transaction_id: _response.Records[0].Orders[0].ID,
            value: _response.Records[0].Total,
            "order total": _response.Records[0].Total,
            "invoice confirmation number": _response.Records[0].InvoiceNo,
            "refund number": _response.Records[0].Orders[0].ID,
          };

          if (
            !pageReload &&
            kmRefundedProps["order total"] &&
            kmRefundedProps["invoice confirmation number"] &&
            kmRefundedProps["refund number"] &&
            kmRefundedProps["order total"] != "" &&
            kmRefundedProps["invoice confirmation number"] != "" &&
            kmRefundedProps["refund number"] != "" &&
            !kissMetricsDone
          ) {
            kissMetricsDone = true;

            tracker("refunded", kmRefundedProps);
          }
          //   kmViewedProps = {
          //     "Order Confirmation No": _response.Records[0].InvoiceNo,
          //     Currency: _response.Records[0].CurrencyCode,
          //     "Total discount": "",
          //     "Coupon code": "",
          //     "Order Total Amount": _response.Records[0].Total,
          //     Fulfilment: _response.Records[0].Orders[0].CustomFields !== null
          //       ? _response.Records[0].Orders[0].CustomFields.filter((item) =>
          //         item.Name.includes("CustomOrderType")
          //       ).length > 0
          //         ? _response.Records[0].Orders[0].CustomFields.filter((item) =>
          //           item.Name.includes("CustomOrderType")
          //         )[0].Values[0]
          //         : ""
          //       : "delivery"
          //   };

          let refundDate: any = getRefundDate(_response?.Records[0]);
          setDateAndTime(moment.unix(refundDate).format("DD MMM YYYY, hh:mma"));
          let order_quantity = 0;
          _response.Records[0].Orders.map((item) => {
            item.CartItemDetails.map((i, j) => {
              if (!i.Quantity.includes("-")) {
                kmRefundedPropsProduct = {
                  currency: _response.Records[0].CurrencyCode,
                  transaction_id: _response.Records[0].Orders[0].ID,
                  value: _response.Records[0].Total,
                  item_id: i.ItemDetail.ID,
                  item_name: i.ItemDetail.Name,
                  "invoice Confirmation No": _response.Records[0].InvoiceNo,
                  "Product id": i.ItemDetail.ID,
                  "Product name": i.ItemDetail.Name,
                  "Store name": item.MerchantDetail.DisplayName,
                  "Product Price": i.SubTotal,
                  "Product sku": i.ItemDetail.SKU ? i.ItemDetail.SKU : "",
                };
                Object.keys(i.ItemDetail.CustomFields).forEach((key) => {
                  if (i.ItemDetail.CustomFields[key].Name == "Brand") {
                    if (i.ItemDetail.CustomFields[key].Values[0] == "Brands") {
                      kmRefundedPropsProduct["Brand Name"] = "";
                    } else {
                      kmRefundedPropsProduct["Brand Name"] =
                        i.ItemDetail.CustomFields[key].Values[0];
                    }
                  }
                });
                Object.keys(item.MerchantDetail.CustomFields).forEach((key) => {
                  if (item.MerchantDetail.CustomFields[key].Name == "Mall") {
                    if (
                      item.MerchantDetail.CustomFields[key].Values[0] == "Mall"
                    ) {
                      kmRefundedPropsProduct["Mall name"] = "";
                    } else {
                      kmRefundedPropsProduct["Mall name"] =
                        item.MerchantDetail.CustomFields[key].Values[0];
                    }
                  }
                });
                if (
                  i.ItemDetail.Variants &&
                  i.ItemDetail.Variants[0] &&
                  i.ItemDetail.Variants[0].GroupName
                ) {
                  let group_Name = i.ItemDetail.Variants[0].GroupName;
                  let var_name = i.ItemDetail.Variants[0].Name;
                  // kmRefundedPropsProduct[`Product ${group_Name}`] = var_name
                }
                order_quantity = parseInt(i.Quantity);
                kmRefundedPropsProduct["Product quantity"] = order_quantity;
                if (
                  !pageReload &&
                  kmRefundedPropsProduct["Product name"] != "Delivery"
                ) {
                  tracker("refundedproduct", kmRefundedPropsProduct);
                }
              }
            });
          });
          //   kmViewedProps["Product quantity"] = order_quantity;
          //   // _kmq.push(["record", "successfulorder", kmViewedProps]);
          //   console.log('kmViewedProps', kmViewedProps)
          //   this.tracker('successfulorder', kmViewedProps)
          setOrderSummaryData(_response.Records[0]);
        }
      });
  };

  const setTypeAndDateTime = (Order) => {
    let type =
      Order.CustomFields !== null
        ? Order.CustomFields?.filter((item) =>
          item?.Name?.includes("CustomOrderType")
        )?.length > 0
          ? Order.CustomFields?.filter((item) =>
            item?.Name?.includes("CustomOrderType")
          )[0]?.Values[0]
          : ""
        : "delivery";
    // kmViewedProps = { ...kmViewedProps, ...{ 'order type': type } }

    let dateAndTime = "";
    dateAndTime = moment
      .unix(Order.CreatedDateTime)
      .format("DD MMM YYYY hh:mma");
    setType(type);
  };
  const setOrderDetails = (item) => {
    let name = "";
    let phoneNumber = "";
    let email = "";
    let _values;
    let delivery;
    let deliveryData;
    let card_type;
    let card_number;
    item?.Orders?.length > 0 &&
      item?.Orders[0]?.CustomFields?.length > 0 &&
      item?.Orders[0]?.CustomFields?.map((item: any) => {
        if (item?.Name == "CustomOrderBuyerDetails") {
          name = JSON.parse(item?.Values[0]).name;
          name = name ? name.split("+").join(" ") : "";
          phoneNumber = JSON.parse(item?.Values[0]).phone;
          email = JSON.parse(item?.Values[0]).email;
        }
        if (item?.Name == "2c2pTransactionResponse") {
          let transactiondetails = JSON.parse(item?.Values[0]);
          if (transactiondetails?.process_by == "GP") {
            card_type = "GrabPay";
          } else {
            card_type = JSON.parse(item?.Values[0]).card_type;
            card_type = capitalizeFirstLetter(card_type);
            card_number = JSON.parse(item?.Values[0]).masked_pan;
            card_number = card_number.slice(card_number?.length - 4);
          }
        }
      });
    {
      orderSummaryList !== null &&
        orderSummaryList?.length > 0 &&
        orderSummaryList?.map((item: any) => {
          let status = "";
          let CustomFieldStatus = "";
          if (item.Notes) {
            if (
              item.Notes.toLowerCase().includes("rejected") ||
              item.Notes.toLowerCase().includes("Rejected") ||
              item.Notes.toLowerCase().includes("declined")
            ) {
              status = "Not Available";
            } else {
              CustomFieldStatus = item.CustomFields
                ? item.CustomFields.filter((_item) =>
                  _item.Name.includes("CustomOrderStatus")
                ).length > 0
                  ? item.CustomFields.filter((_item) =>
                    _item.Name.includes("CustomOrderStatus")
                  )[0].Values[0]
                  : "Created"
                : "Created";
              if (
                CustomFieldStatus == "Preparing - Full Order" ||
                CustomFieldStatus == "Preparing - Partial Order"
              ) {
                status = "Preparing";
              } else if (
                CustomFieldStatus == "Awaiting Delivery Partner" ||
                CustomFieldStatus == "Order in transit" ||
                CustomFieldStatus == "Order out for delivery"
              ) {
                status = "In Transit";
              } else if (
                CustomFieldStatus == "Completed - Full Order" ||
                CustomFieldStatus == "Completed - Partial Order"
              ) {
                if (
                  item.Notes.toLowerCase().includes("rejected") ||
                  item.Notes.toLowerCase().includes("Rejected") ||
                  item.Notes.toLowerCase().includes("declined")
                ) {
                  status = "Refunded";
                } else {
                  status = "Not Available";
                }
              } else if (CustomFieldStatus == "Awaiting Shopper Collection") {
                status = "Ready for Pickup";
              } else {
                status = "Pending";
              }
            }
          } else {
            CustomFieldStatus = item.CustomFields
              ? item.CustomFields.filter((_item) =>
                _item.Name.includes("CustomOrderStatus")
              ).length > 0
                ? item.CustomFields.filter((_item) =>
                  _item.Name.includes("CustomOrderStatus")
                )[0].Values[0]
                : "Created"
              : "Created";
            if (
              CustomFieldStatus == "Completed - Full Order" ||
              CustomFieldStatus == "Completed - Partial Order"
            ) {
              status = "Refunded";
            } else if (
              CustomFieldStatus.toLowerCase().includes("rejected") ||
              CustomFieldStatus.toLowerCase().includes("Rejected") ||
              CustomFieldStatus.toLowerCase().includes("declined")
            ) {
              status = "Refunded";
            } else {
              status = "Pending";
            }
            // status = "Pending"
          }
          item.Status = status;
          if (item && item?.CustomFields !== null) {
            delivery =
              item?.CustomFields !== null
                ? item?.CustomFields?.filter((item: any) =>
                  item?.Name?.includes("CustomOrderDeliveryAddress")
                )?.length > 0
                  ? item?.CustomFields?.filter((item: any) =>
                    item?.Name?.includes("CustomOrderDeliveryAddress")
                  )[0]?.Values[0]
                  : "Created"
                : "Created";
            if (delivery !== "") {
              deliveryData = JSON.parse(delivery);
            }
          }
        });
    }
    setDelivery(deliveryData);
    setCardType(card_type);
    setCardNumber(card_number);
  };
  const setOrderSummaryData = (Data) => {
    let type123 = "";
    if (Data?.Orders?.length > 0) {
      let data = Data.Orders;
      let status = "";
      if (data[0]) {
        type123 =
          data[0]?.CustomFields !== null
            ? data[0]?.CustomFields?.filter((item) =>
              item?.Name?.includes("CustomOrderType")
            )?.length > 0
              ? data[0]?.CustomFields?.filter((item) =>
                item?.Name?.includes("CustomOrderType")
              )[0]?.Values[0]
              : ""
            : "delivery";
        setTypeAndDateTime(data[0]);
      }
      if (Data?.InvoiceStatus !== "") {
        setInvoiceStatus(Data.InvoiceStatus);
      }

      data.map((item, index) => {
        if (
          item &&
          item.MerchantDetail &&
          item.MerchantDetail.ID != MERCHANTIDDELIVERY
        ) {
          status =
            item.CustomFields !== null
              ? item.CustomFields.filter((item) =>
                item.Name.includes("CustomOrderStatus")
              ).length > 0
                ? item.CustomFields.filter((item) =>
                  item.Name.includes("CustomOrderStatus")
                )[0].Values[0]
                : "Created"
              : "Created";

          // kmViewedProps = { ...kmViewedProps, ...{ "order status": status } }
        }
      });
      setOrderStatus(status);
      if (status.includes("Received")) {
        setImageIndex(0);
      } else if (status.includes("Confirmed")) {
        setImageIndex(1);
      } else if (status.includes("Ready") || status.includes("Transit")) {
        setImageIndex(2);
      } else if (status.includes("Collected") || status.includes("Out for")) {
        setImageIndex(3);
      } else if (status.includes("Completed") || status.includes("Delivered")) {
        setImageIndex(4);
      }

      data = data.map((item) => {
        item.CartItemDetails = item.CartItemDetails?.map((item2) => {
          let img = fetchCurrentProduct(item2.ItemDetail);
          item2.Image = img;

          return item2;
        });

        let merchantDetails = item.MerchantDetail;
        let merchantAddress = merchantDetails.CustomFields
          ? merchantDetails.CustomFields.filter((response) =>
            response.Name.includes("Store Address")
          ).length > 0
            ? merchantDetails.CustomFields.filter((response) =>
              response.Name.includes("Store Address")
            )[0].Values[0]
            : ""
          : "";
        let mall = merchantDetails.CustomFields
          ? merchantDetails.CustomFields.filter((response) =>
            response.Name.includes("Mall")
          ).length > 0
            ? merchantDetails.CustomFields.filter((response) =>
              response.Name.includes("Mall")
            )[0].Values[0]
            : ""
          : "";

        item.MerchantDetail.merchantAdress = merchantAddress;
        item.MerchantDetail.mallName = mall;

        return item;
      });
      setOrderSummaryList(data);
    }
    if (Data) {
      setInvoiceData(Data);
      setOrderDetails(Data);
    }
    getOrderStatusText(type123, Data.InvoiceStatus);
  };
  const getRefundDate = (item) => {
    let refundDate = 0;
    item.Orders &&
      item.Orders.map((itemOuter) => {
        itemOuter.CartItemDetails &&
          itemOuter.CartItemDetails.map((itemInner) => {
            if (itemInner.Refund == true) {
              if (refundDate < itemInner.DateTimeCreated) {
                refundDate = itemInner.DateTimeCreated;
              }
            }
          });
      });
    return refundDate;
  };
  const getOrderStatusText = (type, invoiceStatus) => {
    let _summary = "";
    let _title = "";
    let _summary2 = "";
    let _summary3 = "";
    if (type !== "" && type == "pickup") {
      switch (invoiceStatus?.toLowerCase()) {
        case "order received":
          _title = "ORDER RECEIVED";
          _summary =
            "Thank you! We have received your self collection order and it has been sent to the store(s) for processing.";
          _summary2 =
            "We’ll send you a notification when the store(s) confirm your order.";
          break;
        case "order confirmed":
          _title = "ORDER CONFIRMED";
          _summary =
            "Your self collection order has been confirmed and is being prepared by the store(s).";
          _summary2 =
            "We’ll send you another notification when your order is ready for collection.";
          break;
        case "order partially confirmed":
          _title = "ORDER PARTIALLY CONFIRMED";
          _summary =
            "Your self collection order has been partially confirmed and is being prepared by the store(s).";
          _summary2 =
            "We’ll send you another notification when your order is ready for collection.";
          _summary3 =
            "A refund has been initiated for the items not available. We’ll send a separate notification when the refund has been processed.";
          break;
        case "order declined":
          _title = "ORDER DECLINED";
          _summary =
            "Apologies for the inconvenience. Our store(s) could not fulfil your order.";
          _summary2 =
            "A refund has been initiated. We’ll send a separate notification when the refund has been processed.";
          break;
        case "ready for collection":
          _title = "READY FOR COLLECTION";
          _summary =
            "Good news! Your order is ready for collection at our store(s) and has been reserved for you to collect within 7 days.";
          _summary2 =
            "Please show your confirmation email at the store(s) when collecting your order.";
          break;
        case "order ready for collection":
          _title = "READY FOR COLLECTION";
          _summary =
            "Good news! Your order is ready for collection at our store(s) and has been reserved for you to collect within 7 days.";
          _summary2 =
            "Please show your confirmation email at the store(s) when collecting your order.";
          break;
        case "items collected":
          _title = "ITEMS COLLECTED";
          _summary = "Items in your self collection order have been picked up.";
          _summary2 =
            "Please proceed to the store(s) to pick up the remaining items in this order. Thank you!";
          break;
        case "order completed":
          _title = "ORDER COMPLETED";
          _summary =
            "All items in your order have been picked up and your order is complete.";
          _summary2 = "Thank you and see you again soon!";
          break;
        default:
          break;
      }
    } else {
      switch (invoiceStatus?.toLowerCase()) {
        case "order received":
          _title = "ORDER RECEIVED";
          _summary =
            "Thank you! We have received your delivery order and it has been sent to the store(s) for processing.";
          _summary2 =
            "We’ll send you a notification when the store(s) confirm your order.";
          break;
        case "order confirmed":
          _title = "ORDER CONFIRMED";
          _summary =
            "Your delivery order has been confirmed and is being prepared by the store(s). ";
          _summary2 =
            "Your order is estimated to arrive in 3-5 working days. We’ll send you another notification when your order is on the way.";
          break;
        case "order partially confirmed":
          _title = "ORDER PARTIALLY CONFIRMED";
          _summary =
            "Your delivery order has been partially confirmed and is being prepared by the store(s).";
          _summary2 =
            "We’ll send you another notification when your order  is on the way.";
          _summary3 =
            "A refund has been initiated for the items not available. We’ll send a separate notification when the refund has been processed.";
          break;
        case "order declined":
          _title = "ORDER DECLINED";
          _summary =
            "Apologies for the inconvenience. Our store(s) could not fulfil your order.";
          _summary2 =
            "A refund has been initiated. We’ll send a separate notification when the refund has been processed.";
          break;
        case "out for delivery":
          _title = "OUT FOR DELIVERY";
          _summary = "Good news! Your order is out for delivery.";
          _summary2 =
            "Our delivery partner will be sending you a delivery notification to track your order.";
          break;
        case "order delivered":
          _title = "ORDER COMPLETED";
          _summary =
            "All items in your order have been delivered and your order is complete.";
          _summary2 = "Thank you and see you again soon!";
          break;
        case "unsuccessful delivery":
          _title = "UNSUCCESSFUL DELIVERY";
          _summary = "Our delivery partner could not deliver your order.";
          _summary2 =
            "Your order has been returned to the store(s) and a refund will be initiated. We’ll send a separate notification when the refund has been processed.";
          break;
        default:
          break;
      }
    }
    setSummary(_summary);
    setSummary2(_summary2);
    setSummary3(_summary3);
  };
  const fetchCurrentProduct = (response) => {
    let Brand = response?.CustomFields
      ? response?.CustomFields[1]?.Name.includes("Brand")
        ? response?.CustomFields[1]?.Values
        : ""
      : "";
    if (Brand !== null) {
      setbrandNameList([...brandNameList, { ID: response.ID, brand: Brand }]);
    }
    if (response?.ID) {
      if (response?.Media) {
        return response?.Media[0]?.MediaUrl;
      } else {
        return `${process.env.REACT_APP_ARCADIER_API_URL
          }/images/logo-${process.env.REACT_APP_ARCADIER_API_URL?.replace(
            "https://",
            ""
          )}.png`;
      }
    } else if (response.Code) {
      return `${process.env.REACT_APP_ARCADIER_API_URL
        }/images/logo-${process.env.REACT_APP_ARCADIER_API_URL?.replace(
          "https://",
          ""
        )}.png`;
    }
    return response;
  };
  const capitalizeFirstLetter = (str) => {
    var name = "";
    var string;
    for (var i = 0; i <= str?.length - 1; i++) {
      string = str[i];
      if (str[i] == string.toUpperCase()) {
        name += string.toLowerCase();
      } else {
        name += string.toUpperCase();
      }
    }
    return name.toString().charAt(0).toUpperCase() + name.slice(1);
  };

  return (
    <div>
      <div className="viewport"></div>

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />
        {/* /content */}
        <div className="content">
          {/* breadcrumb-back */}
          <div className="breadcrumb-back">
            {/* breadcrumb */}
            <div
              className="breadcrumb"
              style={{ backgroundColor: "rgb(255,255,255,0.3)" }}
            >
              <Link to="/">Home</Link>
              {/* <a href="#">Account</a> */}
              <Link to={`/my-orders/${"refunds"}`}>Returns</Link>
              <a href="">{invoiceNo}</a>
            </div>
            {/* /breadcrumb */}

            <a onClick={() => props?.history?.goBack()} className="backbtn">
              BACK
            </a>
          </div>
          {/* /breadcrumb-back */}

          {/* product listing */}
          <div className="account-page">
            {/* two-columns */}
            <div className="two-columns">
              {/* left panel */}
              <SideMenu props={props} />
              {/* /left panel */}

              {/* /right panel */}
              <div className="right-panel">
                {/* order-detail */}
                <div className="order-detail">
                  {/* summary */}
                  <div className="summary">
                    <div className="title">{"Refund"}</div>

                    {/* detail-qr */}
                    <div className="detail-qr-wrap">
                      {/* detail */}
                      <div className="detail">
                        <div className="msg">
                          {"We would like to inform you that a refund amount of " +
                            formatCurrency(invoiceData.Total) +
                            " for your item(s) listed below has been processed."}
                        </div>
                        <div className="msg">
                          {
                            "Please allow 3-15 days for the refund to be credited."
                          }
                        </div>

                        <div className="detail-list">
                          <div className="item">
                            <div className="property">Refund Date:</div>
                            <div className="value">{dateAndTime}</div>
                          </div>

                          <div className="item">
                            <div className="property">
                              Order Confirmation No:
                            </div>
                            <div className="value">
                              {invoiceData?.InvoiceNo}
                            </div>
                          </div>

                          <div className="item">
                            <div className="property">Fulfilment:</div>
                            <div className="value">
                              {type == "delivery"
                                ? "Delivery"
                                : "Self Collection"}
                            </div>
                          </div>

                          <div className="item">
                            <div className="property">Refunded To:</div>
                            <div className="value">
                              {card_type || card_number
                                ? card_type == "GrabPay"
                                  ? "GrabPay"
                                  : card_type + " card ending " + card_number
                                : ""}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* /detail */}

                      {/* qr-code */}
                      {isDesktopOrLaptop ? (
                        <div
                          className="qr-code-wrap"
                          style={{ marginRight: 40 }}
                        >
                          {invoiceData?.InvoiceNo !== "" &&
                            invoiceData?.InvoiceNo !== undefined && (
                              <div className="qr-code">
                                <QRCODE
                                  className={"qrcodeView"}
                                  level={"H"}
                                  size={220}
                                  includeMargin={true}
                                  value={invoiceNo}
                                />
                              </div>
                            )}
                          <div className="note">
                            Present QR Code in-store for Store Pick Ups
                          </div>
                        </div>
                      ) : (
                        <div className="qr-code-wrap">
                          {invoiceData?.InvoiceNo !== "" &&
                            invoiceData?.InvoiceNo !== undefined && (
                              <div className="qr-code">
                                <QRCODE
                                  className={"qrcodeView"}
                                  level={"H"}
                                  size={220}
                                  includeMargin={true}
                                  value={invoiceNo}
                                />
                              </div>
                            )}
                          <div className="note">
                            Present QR Code in-store for Store Pick Ups
                          </div>
                        </div>
                      )}
                      {/* /qr-code */}
                    </div>
                    {/* detail-qr */}
                  </div>
                  {/* /summary */}

                  {/* listing */}
                  <div className="order-listing">
                    {/* item */}
                    {orderSummaryList?.map((itemOuter: any, index) => {
                      let brands = "";
                      let frxdel = true;
                      let unitNo = 0;
                      let mall = "";
                      let pickupPoint = "";
                      if (itemOuter.CartItemDetails) {
                        itemOuter.CartItemDetails.map((_item, index) => {
                          if (_item.ItemDetail.ID == deliveryItemID) {
                            frxdel = false;
                            deliveryItemPrice = _item.ItemDetail.Price;
                          } else {
                            frxdel = true;
                          }
                        });
                      }
                      if (
                        itemOuter &&
                        itemOuter.MerchantDetail &&
                        itemOuter.MerchantDetail.ID != MERCHANTIDDELIVERY
                      ) {
                        unitNo = itemOuter.MerchantDetail.CustomFields
                          ? itemOuter.MerchantDetail.CustomFields.filter(
                            (_item) => _item.Name.includes("Unit Number")
                          ).length > 0
                            ? itemOuter.MerchantDetail.CustomFields.filter(
                              (_item) => _item.Name.includes("Unit Number")
                            )[0].Values[0]
                            : ""
                          : "";

                        mall = itemOuter.MerchantDetail.CustomFields
                          ? itemOuter.MerchantDetail.CustomFields.filter(
                            (_item) => _item.Name.includes("Mall")
                          ).length > 0
                            ? itemOuter.MerchantDetail.CustomFields.filter(
                              (_item) => _item.Name.includes("Mall")
                            )[0].Values[0]
                            : ""
                          : "";

                        pickupPoint = itemOuter.MerchantDetail.CustomFields
                          ? itemOuter.MerchantDetail.CustomFields.filter(
                            (_item) => _item.Name.includes("Pickup Location")
                          ).length > 0
                            ? itemOuter.MerchantDetail.CustomFields.filter(
                              (_item) =>
                                _item.Name.includes("Pickup Location")
                            )[0].Values[0]
                            : ""
                          : "";
                        return (
                          <div className="item" key={index}>
                            <div className="store-name">
                              {itemOuter?.MerchantDetail?.DisplayName
                                ? itemOuter?.MerchantDetail?.DisplayName
                                : ""}
                            </div>
                            <div className="unit-no">
                              {unitNo + (mall ? ", " + mall : "")}
                            </div>

                            <div className="detail-list">
                              <div className="item">
                                <div className="property">Refund No:</div>
                                <div className="value">{itemOuter.ID}</div>
                              </div>
                              <div className="item">
                                <div className="property">Refund Total:</div>
                                <div className="value">
                                  {formatCurrency(itemOuter.Total)}
                                </div>
                              </div>
                            </div>

                            {/* thumb info wrap */}
                            {itemOuter.CartItemDetails?.map((item, index) => {
                              let status = "";
                              let CustomFieldStatus = "";
                              if (item.Notes) {
                                if (
                                  item.Notes.toLowerCase().includes(
                                    "rejected"
                                  ) ||
                                  item.Notes.toLowerCase().includes(
                                    "Rejected"
                                  ) ||
                                  item.Notes.toLowerCase().includes("declined")
                                ) {
                                  status = "Not Available";
                                } else {
                                  CustomFieldStatus = itemOuter.CustomFields
                                    ? itemOuter.CustomFields.filter((_item) =>
                                      _item.Name.includes("CustomOrderStatus")
                                    ).length > 0
                                      ? itemOuter.CustomFields.filter((_item) =>
                                        _item.Name.includes(
                                          "CustomOrderStatus"
                                        )
                                      )[0].Values[0]
                                      : "Created"
                                    : "Created";

                                  status = "Pending";
                                }
                              } else {
                                CustomFieldStatus = itemOuter.CustomFields
                                  ? itemOuter.CustomFields.filter((_item) =>
                                    _item.Name.includes("CustomOrderStatus")
                                  ).length > 0
                                    ? itemOuter.CustomFields.filter((_item) =>
                                      _item.Name.includes("CustomOrderStatus")
                                    )[0].Values[0]
                                    : "Created"
                                  : "Created";
                                if (
                                  CustomFieldStatus ==
                                  "Completed - Full Order" ||
                                  CustomFieldStatus ==
                                  "Completed - Partial Order"
                                ) {
                                  status = "Refunded";
                                } else if (
                                  CustomFieldStatus.toLowerCase().includes(
                                    "rejected"
                                  ) ||
                                  CustomFieldStatus.toLowerCase().includes(
                                    "Rejected"
                                  ) ||
                                  CustomFieldStatus.toLowerCase().includes(
                                    "declined"
                                  )
                                ) {
                                  status = "Refunded";
                                } else {
                                  status = "Pending";
                                }
                                // status = "Pending"
                              }

                              if (status == "Not Available") {
                                RefundAmount =
                                  item.ItemDetail.Price * item.Quantity;
                              }

                              brandNameList.length > 0 &&
                                brandNameList !== null &&
                                brandNameList.map((item3) => {
                                  if (
                                    item3.ID == item.ItemDetail.ID ||
                                    item3.ID == item.ItemDetail.ParentID
                                  ) {
                                    brands = item3.brand;
                                  }
                                });
                              brands = brands[0]
                                ? brands[0].replace(/&amp;/g, "&")
                                : "";
                              return (
                                item?.Refund == false && (
                                  <div className="thumb-info-wrap" key={index}>
                                    <div className="thumb">
                                      <img src={item.Image} alt="" />
                                    </div>

                                    <div className="info">
                                      <div className="product-name">
                                        {item.ItemDetail.Name}
                                      </div>
                                      <div className="price">
                                        {formatCurrency(item.ItemDetail.Price)}
                                      </div>
                                      <div className="blackbutton">
                                        {status}
                                      </div>
                                      <div className="detail-list">
                                        {item.ItemDetail.Variants &&
                                          item.ItemDetail.Variants.map(
                                            (itemV: any, indexV) => {
                                              return (
                                                <div
                                                  className="item"
                                                  key={indexV}
                                                >
                                                  <div className="property">
                                                    {itemV
                                                      ? itemV?.GroupName ==
                                                        "Color"
                                                        ? "Colour:"
                                                        : itemV?.GroupName + ":"
                                                      : ""}
                                                  </div>
                                                  <div className="value">
                                                    {itemV ? itemV?.Name : ""}
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        <div className="item">
                                          <div className="property">
                                            Refund Qty:
                                          </div>
                                          <div className="value">
                                            {item.Quantity}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                              );
                            })}
                            {/* /thumb info wrap */}
                          </div>
                        );
                      }
                    })}
                  </div>
                  {/* /listing */}

                  {/* total price */}
                  <div className="price-footer">
                    <div className="row subtotal">
                      <div className="property">SUBTOTAL</div>
                      <div className="value">
                        {" "}
                        {invoiceData.Total
                          ? formatCurrency(invoiceData.Total)
                          : ""}
                      </div>
                    </div>

                    {/* <div className="row">
											<div className="property">Promo - MIGHTYPAY</div>
											<div className="value">-$2.00</div>
										</div> */}

                    <div className="row">
                      <div className="property"></div>
                      <div className="value">
                        {" "}
                        {type == "delivery"
                          ? deliveryItemPrice == 0
                            ? "Free"
                            : formatCurrency(deliveryItemPrice)
                          : "Free"}
                      </div>
                    </div>

                    <div className="row total">
                      <div className="property">
                        TOTAL
                        <small>Inclusive of GST where applicable</small>
                      </div>
                      <div className="value">
                        {" "}
                        {invoiceData.Total
                          ? formatCurrency(invoiceData.Total - RefundAmount)
                          : ""}
                      </div>
                    </div>

                    <div className="note">
                      If you have any questions regarding your order, please
                      visit our{" "}
                      <a
                        target="_blank"
                        href="https://www.frasersexperience.com/fr-page.php?CategoryID=744"
                        onClick={() => {
                          let eventData = {
                            "location type": "Refund Details",
                          };
                          tracker(
                            "Opened Order Help and FAQ Screen",
                            eventData
                          );
                        }}
                      >
                        Order Help & FAQ
                      </a>{" "}
                      section
                    </div>
                  </div>
                  {/* /total price */}
                </div>
                {/* /order-detail */}
              </div>
              {/* /right panel */}
            </div>
            {/* /two-columns */}
          </div>
          {/* /product listing */}
        </div>
        {/* /content*/}
      </div>

      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, acf, allCategories } = state.UserReducer;
  return { cart_count, acf, allCategories };
};
const actions = {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
};
export default connect(mapStateToProps, actions)(RefundDetails);
